module.exports = __webpack_public_path__ + "static/template_options_2_weeks-a9a9e2a7abead47632dda0d86fce2aa5.png";